import { useContext } from 'react';
import { ScanManagerContext } from 'src/sections/scan_manager/ScanManagerContext';

const useScanManager = () => {
  const context = useContext(ScanManagerContext);
  if (!context)
    throw new Error('Scan Manager context must be used inside Scan Manager Context Provider');
  return context;
};

export default useScanManager;
